import { useEffect, useRef } from 'react';
import { RefreshCw, WifiOff } from 'lucide-react';
import { useStore, useT } from '../game/context.js';
import { applyUpdate, dismissUpdate, usePwa } from '../pwa.js';
import { Btn } from './components.js';

/** Connectivity and update notices shown under the top bar (T2.9). */
export function PwaNotices() {
  const pwa = usePwa();
  const store = useStore();
  const t = useT();

  // One toast when the game first becomes playable offline (not on every launch).
  const wasReady = useRef(pwa.offlineReady);
  useEffect(() => {
    if (pwa.offlineReady && !wasReady.current) store.toast('success', t('pwa.offlineReady'), 'success');
    wasReady.current = pwa.offlineReady;
  }, [pwa.offlineReady, store, t]);

  const update = () => {
    void applyUpdate();
  };

  return (
    <>
      {!pwa.online && (
        <p className="notice notice--offline" role="status">
          <WifiOff size={16} aria-hidden="true" />
          <span>{t('pwa.offline')}</span>
        </p>
      )}
      {pwa.needRefresh && (
        <section className="notice notice--update" role="status" aria-label={t('pwa.updateTitle')}>
          <RefreshCw size={18} aria-hidden="true" />
          <span className="notice__text">
            <strong>{t('pwa.updateTitle')}</strong>
            <span className="muted small">{t('pwa.updateDesc')}</span>
          </span>
          <span className="notice__actions">
            <Btn size="sm" variant="ghost" onClick={dismissUpdate}>
              {t('pwa.later')}
            </Btn>
            <Btn size="sm" variant="magic" onClick={update}>
              {t('pwa.update')}
            </Btn>
          </span>
        </section>
      )}
    </>
  );
}
